import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Mask = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(57, 57, 85, 0.3);
`;

export const Main = styled.div`
  position: relative;
  z-index: 2;
  padding: 20px 0;
  border-radius: 10px;
  width: 50%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(255, 255, 255);
`;
